import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { MutableCoroutineContext2j9pn5zmhi2pt as MutableCoroutineContext } from './MutableCoroutineContext.mjs';
import { Dispatchers_getInstanceitgtkvqfcnx3 as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import {
  get_keyp54t1phutrkg as get_key,
  StatusListener1jkchgp0onou6 as StatusListener,
  Key_instance6wd16m35aua5 as Key_instance,
  onRemove3k528udkni1ni as onRemove,
} from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { Key_instance2ye2t23iqghop as Key_instance_0 } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineExceptionHandler.mjs';
import {
  report1vfr9zf0i9d9p as report,
  get_viewDebugTarget2umd1p7wjmzxt as get_viewDebugTarget,
  checkLeakAfterDelayr9e6vxihbhwn as checkLeakAfterDelay,
} from '../debugger.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from './ViewWriter.mjs';
import {
  Align_Stretch_getInstancecei5ndh62f1w as Align_Stretch_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
} from '../models/data.mjs';
import {
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  Companion_getInstance31w1ky5wvnamo as Companion_getInstance_0,
  WorkingSemantic_getInstance38e4ialv1t20v as WorkingSemantic_getInstance,
  LoadingSemantic_getInstance2bll1ncm1bbe7 as LoadingSemantic_getInstance,
} from '../models/Theme.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { RView1jxdnn5qf89cm as RView } from './RView.commonHtml.mjs';
import {
  Edges2jf5wl855ambv as Edges,
  Companion_getInstance2eccs74uj90kl as Companion_getInstance_1,
} from '../models/Rect.mjs';
import { minOf33o15vox9quzb as minOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  get_indices3txodfl5wuu5j as get_indices,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { removeAll3o43e67jmwdpc as removeAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  ExceptionHandlers355q12ugblzqr as ExceptionHandlers,
  Companion_getInstanceghpsqwa00d1o as Companion_getInstance_2,
  Companion_getInstance37g5wqg3e7ywq as Companion_getInstance_3,
} from '../exceptions/handling.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { addAndRunListener8g331b1wn43q as addAndRunListener } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  WeakReferencel11chldcck68 as WeakReference,
  identityHashCodemue8eqr5m304 as identityHashCode,
} from '../debugger.js.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { removePrefix279df90bhrqqg as removePrefix } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toString1h6jjoch8cjt8 as toString_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.zd8_1 = false;
        this.ad9_1 = false;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_4() {
  return Companion_instance;
}
function _set_themeAndBack__2re99a($this, value) {
  if (!value.equals($this.rb6_1)) {
    $this.rb6_1 = value;
    $this.ub9(value);
    $this.mb9();
    var _iterator__ex2g4s = $this.ub6_1.m1();
    while (_iterator__ex2g4s.n1()) {
      var child = _iterator__ex2g4s.o1();
      child.oba();
    }
  }
}
function _set_loadCount__8vrevw($this, value) {
  $this.yb6_1 = value;
  if (value === 0 && $this.xb6_1.f2()) {
    $this.xb6_1.oam(false);
    $this.oba();
  } else if (value > 0 && !$this.xb6_1.f2()) {
    $this.xb6_1.oam(true);
    $this.oba();
  }
}
function _set_workCount__2dqm0p($this, value) {
  $this.ab7_1 = value;
  if (value === 0 && $this.zb6_1.f2()) {
    $this.zb6_1.oam(false);
    $this.oba();
  } else if (value > 0 && !$this.zb6_1.f2()) {
    $this.zb6_1.oam(true);
    $this.oba();
  }
}
function contextSetup($this) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (MutableCoroutineContext())();
  this_0.yd8($this.bb7_1);
  // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
  var tmp$ret$0 = new (RViewHelper$contextSetup$$inlined$apply$1())(this_0);
  this_0.yd8(tmp$ret$0);
  this_0.yd8(new (RViewHelper$contextSetup$1())($this));
  this_0.yd8(Dispatchers_getInstance().bad().vac());
  return this_0;
}
function exceptionToMessage$handle(myView, $exception, view) {
  var tmp0_safe_receiver = view.wb6_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bcw(myView, $exception);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = view.tb6_1;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = exceptionToMessage$handle(myView, $exception, tmp2_safe_receiver);
    }
    tmp = tmp_0;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function RViewHelper$clearChildren$lambda(it) {
  it.pba(null);
  it.na9();
  return true;
}
var RViewHelper$contextSetup$1Class;
function RViewHelper$contextSetup$1() {
  if (RViewHelper$contextSetup$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.bd9_1 = this$0;
      }
      fah(reactive) {
        this.bd9_1.yba(reactive);
      }
      eah(reactive) {
        this.bd9_1.zba(reactive);
      }
    }
    protoOf($).e2 = get_key;
    protoOf($).cd = get;
    protoOf($).fp = fold;
    protoOf($).ep = minusKey;
    protoOf($).gp = plus;
    initMetadataForClass($, VOID, VOID, VOID, [StatusListener()]);
    RViewHelper$contextSetup$1Class = $;
  }
  return RViewHelper$contextSetup$1Class;
}
var RViewHelper$contextSetup$$inlined$apply$1Class;
function RViewHelper$contextSetup$$inlined$apply$1() {
  if (RViewHelper$contextSetup$$inlined$apply$1Class === VOID) {
    class $ extends AbstractCoroutineContextElement() {
      constructor($$this$apply, $box) {
        if ($box === VOID)
          $box = {};
        $box.dd9_1 = $$this$apply;
        super(Key_instance_0, $box);
      }
      ya8(context, exception) {
        if (!(exception instanceof CancellationException())) {
          report(exception, toString(this.dd9_1));
        }
        return Unit_instance;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [AbstractCoroutineContextElement(), Element()]);
    RViewHelper$contextSetup$$inlined$apply$1Class = $;
  }
  return RViewHelper$contextSetup$$inlined$apply$1Class;
}
function invoke$_anonymous_$_anonymous_$handle_4cljpa(myView, $it, view) {
  var tmp0_safe_receiver = view.vb6_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.scv(myView, true, $it);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = view.tb6_1;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = invoke$_anonymous_$_anonymous_$handle_4cljpa(myView, $it, tmp2_safe_receiver);
    }
    tmp = tmp_0;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function invoke$_anonymous_$_anonymous_$handle_4cljpa_0(myView, $it, view) {
  var tmp0_safe_receiver = view.vb6_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.scv(myView, false, $it);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = view.tb6_1;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = invoke$_anonymous_$_anonymous_$handle_4cljpa_0(myView, $it, tmp2_safe_receiver);
    }
    tmp = tmp_0;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
var RViewHelperClass;
function RViewHelper() {
  if (RViewHelperClass === VOID) {
    class $ extends ViewWriter() {
      constructor(context) {
        super();
        this.ab6_1 = context;
        this.bb6_1 = false;
        this.cb6_1 = 1.0;
        this.db6_1 = true;
        this.eb6_1 = true;
        this.fb6_1 = null;
        this.gb6_1 = false;
        this.hb6_1 = null;
        this.ib6_1 = null;
        this.jb6_1 = null;
        this.kb6_1 = null;
        this.lb6_1 = Align_Stretch_getInstance();
        this.mb6_1 = Align_Stretch_getInstance();
        this.nb6_1 = null;
        this.ob6_1 = null;
        this.pb6_1 = false;
        this.qb6_1 = Companion_getInstance().zd1_1;
        this.rb6_1 = Companion_getInstance_0().qd1_1.ab1_1;
        this.sb6_1 = false;
        this.tb6_1 = null;
        this.ub6_1 = ArrayList().w();
        this.vb6_1 = null;
        this.wb6_1 = null;
        this.xb6_1 = Signal().hak(false);
        this.yb6_1 = 0;
        this.zb6_1 = Signal().hak(false);
        this.ab7_1 = 0;
        this.bb7_1 = SupervisorJob();
        this.cb7_1 = contextSetup(this);
        this.db7_1 = null;
        this.eb7_1 = null;
      }
      pc() {
        return this.ab6_1;
      }
      cba() {
        return this instanceof RView() ? this : THROW_CCE();
      }
      gb7(_set____db54di) {
        this.cb6_1 = _set____db54di;
      }
      ib7() {
        return this.cb6_1;
      }
      jb7(_set____db54di) {
        this.db6_1 = _set____db54di;
      }
      yb8() {
        return this.db6_1;
      }
      dba(value) {
        this.jb7(value);
      }
      eba() {
        return this.yb8();
      }
      zb8(_set____db54di) {
        this.eb6_1 = _set____db54di;
      }
      ab9() {
        return this.eb6_1;
      }
      bb9(_set____db54di) {
        this.fb6_1 = _set____db54di;
      }
      db9() {
        return this.fb6_1;
      }
      fba(value) {
        this.bb9(value);
      }
      eb9(_set____db54di) {
        this.gb6_1 = _set____db54di;
      }
      gba(value) {
        var tmp;
        var tmp_0 = value;
        if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
          tmp = null;
        } else {
          var tmp_1 = value;
          // Inline function 'kotlin.let' call
          var p0 = (tmp_1 == null ? null : new (Dimension())(tmp_1)).yb1_1;
          tmp = Edges().cd0(p0);
        }
        this.jba(tmp);
      }
      hba() {
        var tmp0_safe_receiver = this.ob9();
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.mb2_1;
      }
      iba(value) {
        this.hb6_1 = value;
        this.mb9();
      }
      jba(value) {
        this.ib6_1 = value;
        this.mb9();
      }
      ob9() {
        return this.ib6_1;
      }
      ib9(_set____db54di) {
        this.nb6_1 = _set____db54di;
      }
      jb9() {
        return this.nb6_1;
      }
      kb9(_set____db54di) {
        this.ob6_1 = _set____db54di;
      }
      lb9() {
        return this.ob6_1;
      }
      kba(value) {
        this.pb6_1 = value;
        this.oba();
      }
      lba(value) {
        this.qb6_1 = value;
        this.oba();
      }
      mba() {
        return this.rb6_1.gb1_1;
      }
      vb9() {
        var tmp0_elvis_lhs = this.hba();
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
          tmp = this.rb6_1.gb1_1.kb0_1.nb2_1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var pad = tmp;
        var tmp1_elvis_lhs = this.db9();
        var tmp_1;
        var tmp_2 = tmp1_elvis_lhs;
        if ((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null) {
          tmp_1 = this.rb6_1.gb1_1.jb0_1;
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        var gap = tmp_1;
        return minOf(new (Dimension())(pad), new (Dimension())(gap)).yb1_1;
      }
      nb9() {
        var tmp0_elvis_lhs = this.ob9();
        // Inline function 'kotlin.let' call
        var it = tmp0_elvis_lhs == null ? this.rb6_1.ib1_1 ? this.mba().kb0_1 : Companion_getInstance_1().bd0_1 : tmp0_elvis_lhs;
        return !(this.hb6_1 == null) ? it.plusEdgesNullable(this.hb6_1) : it;
      }
      nba(theme) {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.let' call
        var it = this.fb7().f2() ? theme.fb1(WorkingSemantic_getInstance()) : theme;
        return this.wba().f2() ? it.fb1(LoadingSemantic_getInstance()) : it;
      }
      mb9() {
      }
      oba() {
        if (equals(this, get_viewDebugTarget())) {
          println('refreshTheming');
        }
        if (!this.sb6_1) {
          if (equals(this, get_viewDebugTarget())) {
            println('refreshTheming abandoned due to not fullyStarted');
          }
          return Unit_instance;
        }
        var tmp0_safe_receiver = this.tb6_1;
        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sb6_1) === false) {
          if (equals(this, get_viewDebugTarget())) {
            println('refreshTheming abandoned due to parent ' + toString_0(this.tb6_1) + ' not being fully started');
          }
          return Unit_instance;
        }
        var tmp;
        if (this.pb6_1) {
          var tmp1_safe_receiver = this.tb6_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mba();
          tmp = tmp2_elvis_lhs == null ? Companion_getInstance_0().qd1_1 : tmp2_elvis_lhs;
        } else {
          var tmp3_safe_receiver = this.tb6_1;
          var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.mba();
          var tmp_0;
          if (tmp4_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_elvis_lhs = tmp4_safe_receiver.yb0_1;
            tmp_0 = tmp0_elvis_lhs == null ? tmp4_safe_receiver : tmp0_elvis_lhs;
          }
          var tmp5_elvis_lhs = tmp_0;
          tmp = tmp5_elvis_lhs == null ? Companion_getInstance_0().qd1_1 : tmp5_elvis_lhs;
        }
        var themeBorrowed = tmp;
        if (equals(this, get_viewDebugTarget())) {
          println('refreshTheming will set!  Parent theme is ' + themeBorrowed.fb0_1);
        }
        var t = this.nba(this.qb6_1.hd1(themeBorrowed));
        if (equals(this, get_viewDebugTarget())) {
          println('refreshTheming will set to ' + t.gb1_1.fb0_1 + '!');
        }
        _set_themeAndBack__2re99a(this, t);
      }
      pba(value) {
        this.tb6_1 = value;
        if (!(this.tb6_1 == null)) {
          this.oba();
        }
      }
      qba() {
        return this.ub6_1;
      }
      rba(view) {
        if (this.bb6_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt to call willAddChild was made');
        }
        view.pba(this instanceof RView() ? this : THROW_CCE());
      }
      sba(index, view) {
        if (this.bb6_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt to call addChild was made');
        }
        if (!(view.tb6_1 === this)) {
          view.pba(this instanceof RView() ? this : THROW_CCE());
        }
        this.ub6_1.y3(index, view);
        this.wb9(index, view);
      }
      tba(view) {
        if (this.bb6_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt to call addChild was made');
        }
        if (!(view.tb6_1 === this)) {
          view.pba(this instanceof RView() ? this : THROW_CCE());
        }
        var index = this.qba().p1();
        this.ub6_1.y3(index, view);
        this.wb9(index, view);
      }
      zb9(index) {
        if (this.bb6_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt to call removeChild was made');
        }
        if (!(0 <= index ? index <= (this.qba().p1() - 1 | 0) : false))
          throw IllegalArgumentException().a1('' + index + ' not in range ' + get_indices(this.qba()).toString());
        this.yb9(index);
        // Inline function 'kotlin.also' call
        this.ub6_1.z3(index).na9();
      }
      uba(view) {
        if (this.bb6_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt to call removeChild was made');
        }
        var i = this.qba().s1(view);
        if (!(i === -1)) {
          this.zb9(i);
        } else {
          throw IllegalStateException().o4(view.toString() + ' is not a child of ' + this.toString() + '!');
        }
      }
      bba() {
        if (this.bb6_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt call to was made ');
        }
        this.aba();
        removeAll(this.ub6_1, RViewHelper$clearChildren$lambda);
      }
      vba(exceptionHandler) {
        var tmp0_safe_receiver = this.vb6_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp0_safe_receiver.vba(exceptionHandler);
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this;
          // Inline function 'kotlin.apply' call
          var this_0 = new (ExceptionHandlers())();
          this_0.vba(exceptionHandler);
          tmp_0.vb6_1 = this_0;
        }
      }
      wba() {
        return this.xb6_1;
      }
      fb7() {
        return this.zb6_1;
      }
      ga2() {
        return this.cb7_1;
      }
      xba() {
        return this.ga2().ep(Key_instance);
      }
      yba(readable) {
        var loading = {_v: false};
        var excEnder = {_v: null};
        var r = addAndRunListener(readable, () => {
          // Inline function 'com.lightningkite.kiteui.onMainThread' call
          var s = readable.sah();
          var tmp = loading._v;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var tmp_0 = _ReactiveState___get_raw__impl__92ipya(s);
          if (!(tmp === !!(tmp_0 instanceof InternalReactiveNotReady()))) {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_1 = _ReactiveState___get_raw__impl__92ipya(s);
            if (!(tmp_1 instanceof InternalReactiveNotReady())) {
              var _unary__edvuaz = this.ab7_1;
              _set_workCount__2dqm0p(this, _unary__edvuaz - 1 | 0);
            } else {
              var _unary__edvuaz_0 = this.ab7_1;
              _set_workCount__2dqm0p(this, _unary__edvuaz_0 + 1 | 0);
            }
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_2 = _ReactiveState___get_raw__impl__92ipya(s);
            var tmp$ret$2 = !(tmp_2 instanceof InternalReactiveNotReady());
            loading._v = !tmp$ret$2;
          }
          var tmp0_safe_receiver = excEnder._v;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver();
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.exception' call
          var tmp_3 = _ReactiveState___get_raw__impl__92ipya(s);
          var tmp0_safe_receiver_0 = tmp_3 instanceof InternalReactiveThrownException() ? tmp_3 : null;
          var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.uah_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var myView = this instanceof RView() ? this : THROW_CCE();
            var tmp0_elvis_lhs = invoke$_anonymous_$_anonymous_$handle_4cljpa(myView, tmp1_safe_receiver, myView);
            var tmp1_safe_receiver_0 = tmp0_elvis_lhs == null ? Companion_getInstance_2().ycv_1.scv(myView, true, tmp1_safe_receiver) : tmp0_elvis_lhs;
            if (tmp1_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              excEnder._v = tmp1_safe_receiver_0;
            }
          }
          return Unit_instance;
        });
        onRemove(this, r);
        return r;
      }
      zba(readable) {
        var loading = {_v: false};
        var excEnder = {_v: null};
        var r = addAndRunListener(readable, () => {
          // Inline function 'com.lightningkite.kiteui.onMainThread' call
          var s = readable.sah();
          var tmp = loading._v;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var tmp_0 = _ReactiveState___get_raw__impl__92ipya(s);
          if (!(tmp === !!(tmp_0 instanceof InternalReactiveNotReady()))) {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_1 = _ReactiveState___get_raw__impl__92ipya(s);
            if (!(tmp_1 instanceof InternalReactiveNotReady())) {
              var _unary__edvuaz = this.yb6_1;
              _set_loadCount__8vrevw(this, _unary__edvuaz - 1 | 0);
            } else {
              var _unary__edvuaz_0 = this.yb6_1;
              _set_loadCount__8vrevw(this, _unary__edvuaz_0 + 1 | 0);
            }
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_2 = _ReactiveState___get_raw__impl__92ipya(s);
            var tmp$ret$2 = !(tmp_2 instanceof InternalReactiveNotReady());
            loading._v = !tmp$ret$2;
          }
          var tmp0_safe_receiver = excEnder._v;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver();
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.exception' call
          var tmp_3 = _ReactiveState___get_raw__impl__92ipya(s);
          var tmp0_safe_receiver_0 = tmp_3 instanceof InternalReactiveThrownException() ? tmp_3 : null;
          var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.uah_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var myView = this instanceof RView() ? this : THROW_CCE();
            var tmp0_elvis_lhs = invoke$_anonymous_$_anonymous_$handle_4cljpa_0(myView, tmp1_safe_receiver, myView);
            var tmp1_safe_receiver_0 = tmp0_elvis_lhs == null ? Companion_getInstance_2().ycv_1.scv(myView, false, tmp1_safe_receiver) : tmp0_elvis_lhs;
            if (tmp1_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              excEnder._v = tmp1_safe_receiver_0;
            }
          }
          return Unit_instance;
        });
        onRemove(this, r);
        return r;
      }
      abb(exception) {
        var myView = this instanceof RView() ? this : THROW_CCE();
        var tmp0_elvis_lhs = exceptionToMessage$handle(myView, exception, myView);
        return tmp0_elvis_lhs == null ? Companion_getInstance_3().jcw_1.bcw(myView, exception) : tmp0_elvis_lhs;
      }
      na9() {
        this.bb7_1.oa3();
        if (Companion_instance.ad9_1) {
          var inductionVariable = get_lastIndex(this.ub6_1);
          if (0 <= inductionVariable)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + -1 | 0;
              this.yb9(index);
              this.ub6_1.z3(index).na9();
            }
             while (0 <= inductionVariable);
        } else {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = this.ub6_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            element.na9();
          }
          this.ub6_1.v3();
        }
        if (Companion_instance.zd8_1) {
          this.sb9();
        }
        this.bb6_1 = true;
        this.pba(null);
      }
      sb9() {
        checkLeakAfterDelay(new (WeakReference())(this), 1000n);
      }
      bbb() {
        this.sb6_1 = true;
        this.oba();
      }
      fb9(_set____db54di) {
        this.db7_1 = _set____db54di;
      }
      hb9() {
        return this.db7_1;
      }
      toString() {
        var tmp0_elvis_lhs = this.hb9();
        return tmp0_elvis_lhs == null ? this.mba().fb0_1 + ' ' + removePrefix(toString(getKClassFromExpression(this)), 'class ') + '@' + toString_1(identityHashCode(this), 16) : tmp0_elvis_lhs;
      }
      cbb(_this__u8e3s4) {
        return _this__u8e3s4.zbe(this);
      }
    }
    initMetadataForClass($, 'RViewHelper', VOID, VOID, [ViewWriter(), CoroutineScope()]);
    RViewHelperClass = $;
  }
  return RViewHelperClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  RViewHelper as RViewHelpernvzwiwlyoaxk,
};
//endregion

//# sourceMappingURL=RViewHelper.mjs.map
